<template>
  <div class="container">
    <div class="header">新建群发</div>
    <div class="main" style="display: flex;">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="14.0rem" style="width: 80.0rem;">
        <div class="form-header">
          <el-form-item label="任务名称：">
            <el-input clearable v-model="form.name"></el-input>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item label="发送对象：">
            <el-radio-group v-model="form.scope" @change="changeType">
              <el-radio label="1">全部</el-radio>
              <el-radio label="2">按成员</el-radio>
              <el-radio label="3">按客户标签</el-radio>
              <el-radio label="5">按客户群</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.scope === '2'" label="群发成员：">
            <div class="person">
              <el-tag  effect="plain" v-for="item of names" :key="item">
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="addContact">前往添加</el-button>
          </el-form-item>
          <el-form-item v-if="form.scope === '3'" label="选择标签：">
            <div class="person">
              <el-tag v-for="item of arrth" style="margin: 12px 12px 0 0"  effect="plain" :key="item">
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="onTagDialog()">前往添加</el-button>
          </el-form-item>
          <el-form-item v-if="form.scope === '5'" label="选择群：">
            <div v-if="chatName" class="person">
              <el-tag  effect="plain">
                {{ chatName }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="addGroupChat">前往添加</el-button>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item label="文字：">
            <el-input clearable type="textarea" autosize="true" v-model="form.desc"></el-input>
          </el-form-item>
          <el-form-item label="内容类型：">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="无">无</el-radio>
              <el-radio label="图片">图片</el-radio>
              <el-radio label="图文">图文</el-radio>
              <el-radio label="小程序">小程序</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.type === '小程序'" label="小程序名称：">
            <el-input clearable v-model="form.mini_name"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '小程序'" label="小程序ID：">
            <el-input clearable v-model="form.mini_id"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '小程序'" label="小程序路径：">
            <el-input clearable v-model="form.link_url"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '小程序'" label="小程序封面：">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg?usertoken=' +
              tooken.usertoken +
              '&type=1&account_id=' +
              this.tooken.account_id
            " :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="handleBeforeUpload"
              :on-success="handleSuccess" :before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="fileList"
              :list-type="listType" :accept="accept" :limit="1">
              <el-button type="primary">
                上传{{ form.type === "小程序" ? "图片" : form.type }}
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="form.type === '图文'" label="标题：">
            <el-input clearable v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type === '图文'" label="链接：">
            <el-input clearable v-model="form.link_url"></el-input>
          </el-form-item>
          <el-form-item v-if="
            form.type === '图文' ||
            form.type === '文件' ||
            form.type === '视频' ||
            form.type === '图片'
          " :label="form.type === '图文' ? '封面' : form.type + '：'">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg?usertoken=' +
              tooken.usertoken +
              '&type=1&account_id=' +
              this.tooken.account_id
            " :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="handleBeforeUpload"
              :on-success="handleSuccess" :before-remove="beforeRemove" :on-exceed="handleExceed" :file-list="fileList"
              :list-type="listType" :accept="accept" :limit="1">
              <el-button type="primary">
                上传{{ form.type === "图文" ? "图片" : form.type }}
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="form.type === '图文'" label="描述：">
            <el-input clearable type="textarea" autosize="true" v-model="form.describe"></el-input>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width=".0rem">
            <el-button type="primary" style="width: 12.0rem" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button plain style="width: 12.0rem" @click="$router.back()">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="con-right">
        <img class="mobile-img" src="../../../assets/smartPhone.png" alt="" srcset="" />
        <div class="mobile">
          <div class="list">
            <!-- 任务名称 -->
            <div class="list-item" v-show="form.name">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r" style="
                    width: 70%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    background: #fff;
                    padding: 5px;
                    border-radius: 4px;
                  ">
                {{ form.name }}
              </div>
            </div>
            <!-- 文字 -->
            <div class="list-item" v-show="form.desc">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r" style="
                    width: 70%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    background: #fff;
                    padding: 5px;
                    border-radius: 4px;
                  ">
                {{ form.desc }}
              </div>
            </div>
            <!-- 图片 -->
            <div class="list-item" v-show="form.type === '图片' && form.file != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-r">
                <img :src="form.file" />
              </div>
            </div>
            <!-- 图文 -->
            <div class="list-item" v-show="form.type === '图文' && form.title != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-b-a">
                <div style="width: 50%; margin-right: 1.0rem">
                  <div class="list-item-r-t">{{ form.title }}</div>
                  <div class="list-item-r-t">{{ form.link_url }}</div>
                  <div class="list-item-r-t">{{ form.describe }}</div>
                </div>
                <div class="list-item-r-d" v-if="form.file">
                  <img :src="form.file" />
                </div>
              </div>
            </div>
            <!-- 小程序 -->
            <div class="list-item" v-show="form.type === '小程序' && form.mini_name != ''">
              <div class="list-item-l">
                <img class="list-item-l-avatar" src="../../../assets/logoCircle.png" />
              </div>
              <div class="list-item-b-a">
                <div style="width: 50%; margin-right: 1.0rem">
                  <div class="list-item-r-t">{{ form.mini_name }}</div>
                  <div class="list-item-r-t">{{ form.mini_id }}</div>
                  <div class="list-item-r-t">{{ form.link_url }}</div>
                </div>
                <div class="list-item-r-d" v-if="form.file">
                  <img :src="form.file" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog center :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <mail-list ref="drawer" :checkbox="checkbox" :module="module" :is-group="isGroup"
      @handleSelect="handleSelect"></mail-list>
    <el-dialog title="请选择标签" center :visible.sync="dialogTableVisible">
      <div v-for="item of tags" :key="item.group_id" class="tag-item">
        <el-checkbox v-model="item.checkAll" @change="handleCheckAllChange(item)">{{ item.group_name }}</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="item.checkedCities" @change="handleCheckedCitiesChange(item)">
          <el-checkbox v-for="city in item.child" :label="city" :key="city.tag_id">{{ city.tag_name }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="offDialog">确 定</el-button>
      </span>
    </el-dialog>
    <right-people ref="dialog" :selectData="selectData" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  components: {
    rightPeople
  },
  data() {
    return {
      form: {
        scope: "1",
        mini_name: "",
        mini_id: "",
        link_url: "/pages/page/index.html",
        title: "",
        type: "",
        desc: "",
        file: "",
        link: "",
        linkTitle: "",
        linkCover: "",
        time: "",
        userid: "",
        describe: "",
        user_list: [],
        chat_id: "",
        name: ''
      },
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
        file: [{ required: true, message: "请选择文件", trigger: "blur" }],
        link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        linkTitle: [
          { required: true, message: "请输入链接标题", trigger: "blur" },
        ],
        linkCover: [{ required: true, message: "请选择文件", trigger: "blur" }],
      },
      fileList: [],
      // 上传图片地址
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      accept: "",
      listType: "",
      tip: "",
      tooken: {},
      names: [],
      media_id: "",
      dialogTableVisible: false,
      tags: [],
      arrth: [],
      isGroup: false,
      module: "",
      selectData: [],
      chatName: "",
      checkbox: false,
      selectionDepartment: true,
      selectionlable: true,
      check_user: {},
      chat: [],
      sender: ''
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    if (!this.$route.query.id) {
      this.form.type = "无";
      return;
    }
    this.getData();
    this.getdata()
  },
  methods: {
    handleCheckAllChange(val) {
      const findItem = this.tags.find((item) => {
        return item.group_id === val.group_id;
      });
      findItem.checkedCities = val.checkAll ? findItem.child : [];
      findItem.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      const findItem = this.tags.find((item) => {
        return item.group_id === value.group_id;
      });
      let checkedCount = value.checkedCities.length;
      findItem.checkAll = checkedCount === findItem.child.length;
      findItem.isIndeterminate =
        checkedCount > 0 && checkedCount < findItem.child.length;
    },
    offDialog() {
      const arr = [];
      for (var a = 0; a < this.tags.length; a++) {
        for (var k = 0; k < this.tags[a].checkedCities.length; k++) {
          arr.push(this.tags[a].checkedCities[k].tag_name);
        }
      }
      this.group_label = arr.toString();
      this.arrth = arr;
      this.dialogTableVisible = false;
    },
    getLabelListUseAdmin() {
      this.axios
        .post(
          "/crm/Assistant/getLabelListUseAdmin",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          let data = res.data.data;

          data.map((item) => {
            item.checkAll = false;
            item.checkedCities = [];
            item.isIndeterminate = true;
          });
          if (this.group_label) {
            // 回显选中数据
            this.group_label = JSON.parse(this.group_label);

            for (const d of data) {
              for (const g of this.group_label) {
                // 因为需要回显数据， 需要在全部数据内寻找与之对应的提交数据， 传递给全部数据中已选中字段checkedCities(已选中字段)
                if (d.group_id === g.group_id) {
                  // 由于全部数据checkedCities（已选中字段）只有与全部数据内的child相同才能回显选中效果，而提交后的child不行
                  // 因为提交的child对象虽然与全部数据对象内容一样，但两个对象是不相等的，它们并不是一个引用
                  // 对提交数据child与全部数据child比较，当相等时把全部数据的child相同条目传入checkedCities(已选中字段)
                  for (const c of g.child) {
                    for (const k of d.child) {
                      if (c.tag_id === k.tag_id) {
                        d.checkedCities.push(k);
                      }
                    }
                  }
                  let checkedCount = d.checkedCities.length;
                  d.checkAll = checkedCount === d.child.length;
                  d.isIndeterminate =
                    checkedCount > 0 && checkedCount < d.child.length;
                }
              }
            }
          }
          this.tags = data;
        })
        .catch(function (err) { });
    },
    onTagDialog() {
      this.dialogTableVisible = true;
      this.getLabelListUseAdmin();
    },
    async getdata() {
      const { data: res } = await this.axios({
        url: `/crm/GroupSop/getList`,
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      if (res.code == 1) {
        const d = res.data.data[0];
        const chatUserId = d.chat_id.split(",");
        this.chat = d.chat_user_arrays.map((i, index) => {
          return {
            name: i.chat_names,
            id: chatUserId[index],
          };
        });

        this.check_user = {
          userid: d.check_userid,
          name: d.check_userid_name,
        };

        this.setAccept();
      }
    },
    addContact() {
      this.selectData = this.check_user;
      this.module = "getAddressBook";
      this.checkbox = true;
      this.isGroup = true;
      this.selectionDepartment = true;
      this.selectionlable = false
      this.$refs.dialog.open();
    },
    addGroupChat() {
      this.selectData = this.chat
      this.selectionlable = true;
      this.selectionDepartment = false
      this.checkbox = true;
      this.module = "getClientBaseList";
      this.$refs.drawer.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getClientBaseList":
          this.chat = person;
          const chatid = this.chat.map((i) => {
            return i.owner;
          });
          const channame = this.chat.map((i) => {
            return i.name;
          });
          this.sender = String(chatid)
          this.chatName = String(channame)
          break;
        case "getUserLists":
          this.form.userid = person.userid;
          this.names = person;
          break;
        case "getAddressBook":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.form.userid = userid.join();
          this.names = user;
          this.check_user = {
            userid,
            user,
          };
          break;
        default:
          break;
      }
    },
    async getData() {
      await this.axios
        .post(
          "/crm/Assistant/getMaterialOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.form.desc = data.content;
            this.form.linkTitle = data.link_title;
            this.form.link = data.link_url;
            this.form.title = data.title;
            this.form.type = data.type;
            this.form.file = data.url;
            this.fileList.push({ url: this.form.file, name: data.file_name });
            this.setAccept();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      this.form.file = "";
      this.fileList = [];
      this.form.link = "";
      this.form.linkTitle = "";
      this.form.linkCover = "";
      this.setAccept();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "视频":
          this.listType = "text";
          this.tip = "只能上传MP4格式文件，且不超过10MB";
          this.accept = ".mp4";
          break;
        case "文件":
          this.listType = "text";
          this.tip = "不能超过20MB";
          this.accept = "";
          break;
        case "链接":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        default:
          break;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) { },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (this.form.type === "图片" || this.form.type === "链接") {
        if (size > 2) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "视频") {
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "文件") {
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      this.form.file = response.data.url;
      this.media_id = response.data.media_id;
      this.fileList.push(this.form.file);
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.file = [];
      this.fileList = [];
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    submitForm(formName) {
      if (this.form.link == "") {
        this.form.link = this.form.link_url
      }
      this.axios
        .post(
          "/crm/Assistant/addMass",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            page: this.yeshu,
            scope: this.form.scope,
            content: this.form.desc,
            title: this.form.title,
            type: this.form.type,
            describe: this.form.desc,
            url: this.form.file,
            link_url: this.form.link_url,
            describe: this.form.describe,
            mini_name: this.form.mini_name,
            mini_id: this.form.mini_id,
            userid: this.form.userid,
            media_id: this.media_id,
            group_label: this.group_label,
            sender: this.sender,
            name: this.form.name
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.$router.replace("groupSend");
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    submit() {
      this.axios
        .post(
          `/crm/Assistant/${url}`,
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
            type: this.form.type,
            content: this.form.desc,
            title: this.form.title,
            url: this.form.file,
            link_url: this.form.link,
            link_title: this.form.linkTitle,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            this.$router.go(-1);
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.addBtn {
  margin-top: 2.0rem;
}

.main {
  margin-top: 4.0rem;
}

.form-header,
.form-content {
  padding-top: 38px;
  padding-right: 22px;
  overflow: hidden;
}

.form-content,
.form-footer {
  margin-top: 2.0rem;
}

.el-upload-list__item-thumbnail {
  width: 10.0rem;
  height: 10.0rem;
}

.tag-item {
  margin-top: 32px;
  border-bottom: .1rem dashed #dddddd;
  padding-bottom: 2.0rem;
}

.tag-item:nth-child(1) {
  margin-top: 0;
}

.con-right {
  width: 375px;
  margin-left: 26.0rem;
}

.mobile {
  position: relative;
  top: 11.0rem;
  left: 45px;
  width: 70%;
}

.mobile-img {
  width: 19.59%;
  position: absolute;
}

.list-item {
  display: flex;
  margin: 1.0rem 15px;
}

.list-item-l {
  margin-right: 6px;
}

.list-item-l img {
  width: 4.0rem;
  border-radius: 50%;
}

.list-item-r,
.list-item-b-a {
  color: #666;
  font-size: 12px;
}

.list-item-b-a {
  background: #fff;
  border: .1rem solid #eee;
  padding: 1.0rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.list-item-r img {
  width: 84%;
}

.list-item-r-d img {
  width: 84%;
  height: 5.0rem;
}

.list-item-r-t {
  line-height: 1.5;
}

.list-item-b-a .list-item-r-t {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
